import type { PullRequestInput, PullResponse, PushRequest, PushResponse } from "@hq/contracts";
import type { contract } from "@hq/contracts";
import { createORPCClient } from "@orpc/client";
import { RPCLink, type RPCLinkOptions } from "@orpc/client/fetch";
import type { ContractRouterClient } from "@orpc/contract";

/** The two calls the sync engine makes. The fake server in `./testing` implements it in memory. */
export interface SyncTransport {
  push(req: PushRequest): Promise<PushResponse>;
  pull(req: PullRequestInput): Promise<PullResponse>;
}

/** The typed oRPC client for the application contract. */
export type RpcClient = ContractRouterClient<typeof contract>;

export type RpcClientOptions = {
  /** Base URL of the RPC handler, e.g. `https://api.example.com/rpc`. */
  url: string;
  headers?: Record<string, string>;
  fetch?: RPCLinkOptions<Record<string, never>>["fetch"];
};

/** A typed oRPC client over fetch. The app constructs one and hands it to `createRpcTransport`. */
export function createRpcClient(options: RpcClientOptions): RpcClient {
  const link = new RPCLink({
    url: options.url,
    ...(options.fetch ? { fetch: options.fetch } : {}),
    headers: options.headers ?? {},
  });
  return createORPCClient<RpcClient>(link);
}

export function createRpcTransport(client: RpcClient): SyncTransport {
  return {
    push: (req) => client.sync.push(req),
    pull: (req) => client.sync.pull(req),
  };
}
